<div class="moedas-search">
   <input type="text" [placeholder]="placeholder" (keyup)="changeSearch.emit($event)" />
   <div class="button">
      <button type="submit" class="button"><i class="material-icons">search</i></button>
   </div>
</div>
